import config from "../config";
import axios from "axios";

export async function createOrder(payload) {
  const headers = { "Content-Type": "application/json; charset=UTF-8" };

  const data = JSON.stringify(payload);

  return axios.post(`${config.BASE_URL}/payment_link/v1/orders`, data, { headers });
}

export async function fetchPaymentLink(pathname) {
  const headers = { "Content-Type": "application/json; charset=UTF-8" };

  return axios.get(`${config.BASE_URL}/payment_link/v1/${pathname}`, { headers });
}
